export default "__VITE_ASSET__Dye9CZLS__"